import { generateState } from '../builder'

export default {
  characterFunctions: [],
  ...generateState('getCharacterFunctions'),
}
